import { baseDocSerializer, docTypeHash } from "@megaron/resource";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export const invoiceDraftDocSerializer = Serializers.object({
  ...baseDocSerializer("invoice-draft").fields,
  draftUuid: uuidSerializer,
  invoiceNumber: Serializers.string,
  createdAt: Serializers.datetime,
});

export type InvoiceDraftDoc = SerializerValue<typeof invoiceDraftDocSerializer>;

export const invoiceDraftDocTypeHash = docTypeHash(invoiceDraftDocSerializer);
